<template>
  <div class="abuse-report">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader name="Abuse report"></ContentHeader>
        <div class="abuse-report">
          <h4>{{abuseReport.title.rendered}}</h4>
          <hr>
          <p><strong><i class="fas fa-user fa-fw"></i> Reported by:</strong> {{abuseReport._embedded.author[0].name}}</p>
          <strong><i class="fas fa-exclamation-triangle fa-fw"></i> Abuse report:</strong><br>
          <p v-html="abuseReport.content.rendered"></p>
          <strong><i class="fas fa-lightbulb fa-fw"></i> Idea that was reported:</strong><br><br>
          <Ideas v-if="ideaContent.length > 0" :ideas="ideaContent"></Ideas>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import Ideas from '@/components/Ideas'
import PreContentHeader from '@/components/PreContentHeader'
import { mapGetters } from 'vuex'
export default {
  components: {
    PreContentHeader,
    ContentHeader,
    Ideas
  },
  data () {
    return {
      abuseReport: null,
      ideaContent: [],
      contentReady: false,
      contentLoadError: ''
    }
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'isAdmin'
    ])
  },
  methods: {
    loadIdea: function (id) {
      WordpressRestAPI.getViewContent('idea/' + id + '?_embed')
        .then(response => {
          this.ideaContent.push(response.data)
          this.contentReady = true
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with loading this idea. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    },
    loadContent: function () {
      WordpressRestAPI.getViewContent('abuse_report/' + this.$route.params.id + '?_embed')
        .then(response => {
          this.abuseReport = response.data
          document.title = response.data.title.rendered + ' - ThinkTank'
          this.loadIdea(this.abuseReport.idea_post_id_report_abuse[0])
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with loading this abuse report. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    }
  },
  created () {
    this.loadContent()
  },
  watch: {
    '$route' (to, from) {
      document.title = this.$route.params.slug.replace(/-/g, ' ') + ' - ThinkTank'
      this.loadContent()
    },
    isAdmin (to, from) {
      // If user is not admin restrict this page and change route to home page
      console.log(to)
      if (!to) {
        this.$router.push('/')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/SingleAbuseReport.vue